module.exports = __webpack_public_path__ + "img/Болезнь Хаглунда.39b8fa1f.jpg";